import numeral from 'numeral'
import { func, string } from 'prop-types'
import { PureComponent } from 'react'
import Currency from '../../Inputs/Currency'
import { kuiperClassNames } from '../../utils'
import Cell from '../Cell'

import './styles.scss'

const EMPTY_STRING = ''
const EM_DASH = '—'

const valueToString = (value) => numeral(value).format('0,0')
const valueToInteger = (value) => numeral(value).value()

class CurrencyCell extends PureComponent {
  static propTypes = {
    budgetId: string,
    entityId: string,
    getCellContents: func.isRequired,
    onCellBlur: func.isRequired,
    onChange: func.isRequired,
    title: string.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      value: this.props.getCellContents(this.props),
      inFocus: false,
    }
  }

  componentDidUpdate(prevProps) {
    const prevContent = prevProps.getCellContents(this.props)
    const content = this.props.getCellContents(this.props)
    if (content !== prevContent) {
      if (prevContent !== '0') {
        this.onChange(content)
      }
    }
  }

  onChange = (value) => {
    this.setState({ value })
  }

  handleFocus = () => {
    if (this.currencyInput) this.currencyInput.focus()

    this.setState((prevState) => {
      const formattedValue = valueToInteger(prevState.value)
      return {
        value: formattedValue,
        inFocus: true,
      }
    })
  }

  saveAndSetState = (value) => {
    const cleanedValue = valueToInteger(value)
    const emptyValue = cleanedValue === 0
    const emptyStartingValue =
      this.props.getCellContents(this.props) === EM_DASH
    const changedValue =
      valueToInteger(this.props.getCellContents(this.props)) !== cleanedValue
    const budgetRemoved = emptyValue && !emptyStartingValue

    if (budgetRemoved) {
      this.props.onChange(this.props.entityId, this.props.budgetId, null)
    } else if (changedValue) {
      this.props.onChange(
        this.props.entityId,
        this.props.budgetId,
        cleanedValue
      )
    }

    this.setState(() => {
      const formattedValue = emptyValue ? EMPTY_STRING : valueToString(value)

      return {
        value: formattedValue,
        inFocus: false,
      }
    })
  }

  get value() {
    const emptyBudget = [EMPTY_STRING, EM_DASH].includes(this.state.value)
    const activeCell = this.state.inFocus
    let value = emptyBudget && !activeCell ? EM_DASH : this.state.value

    if (!activeCell && !emptyBudget) value = `$${value}`

    return value
  }

  get contents() {
    return (
      <Currency
        ariaLabel={this.props.title}
        ref={(input) => {
          this.currencyInput = input
        }}
        theme="white"
        value={this.value}
        onBlur={this.saveAndSetState}
        onChange={this.onChange}
        displayCurrencySymbol={false}
      />
    )
  }

  render() {
    return (
      <Cell
        {...this.props}
        onBlur={this.props.onCellBlur}
        onClick={this.handleFocus}
        className={kuiperClassNames('currency-cell')}
      >
        {this.contents}
      </Cell>
    )
  }
}

export default CurrencyCell
